export const POLLING_TIMECONFIG = {
	RETRY_AFTER: 30000,
	POLLING_INTERVAL_IN_SEC: 90,
};
